import {
    StepVariables,
    ToolContext,
} from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

type StepTypes = "start" | "submit";

const TOOL_STORE_LOCATOR_STEPS: Record<StepTypes, StepVariables> = {
    start: {
        stepName: "kies locatie",
        stepNumber: 1,
        placement: "vind je winkel:winkels",
        result: {},
        option: "",
    },
    submit: {
        stepName: "winkel gekozen",
        stepNumber: 2,
        placement: "winkels:", // override in Steptracker
        result: {}, // storeId + zipCode
        option: "",
    },
};

const TOOL_STORE_LOCATOR_CONTEXT: Readonly<ToolContext> = {
    name: "store locator",
    type: "form",
};

export { TOOL_STORE_LOCATOR_STEPS, TOOL_STORE_LOCATOR_CONTEXT };
